module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-04-fddd9207528bffc0e971e59ebccddc8b.png";